<template>
  <div class="page">
    <sunset-note-stats-query-bar v-slot="{ params, meta, query, currentUser }">
      <section>
        <h2>
          All notes
        </h2>

        <NoteStatsCsvButton mode="notes-global" :params="params" :query="query" />

        <!-- refactored: pass the single params/meta/query API -->
        <PaginatedGlobalNotes
            :params="params"
            :meta="meta"
            :query="query"
        />
      </section>
    </sunset-note-stats-query-bar>
  </div>
</template>

<script>
import PaginatedGlobalNotes from './components/global_notes_detailed/global_notes_detailed.vue';
import loadingCube from 'loaders/record_loader.vue';
import SunsetNoteStatsQueryBar from 'pages/sunset/reports/notestats/components/shared/query_controls.vue';
import NoteStatsCsvButton from 'pages/sunset/reports/notestats/components/shared/csv_button.vue';

export default {
  name: 'sunset_user_notes_details',
  components: {
    NoteStatsCsvButton,
    SunsetNoteStatsQueryBar,
    loadingCube,
    PaginatedGlobalNotes,
  },
};
</script>

<style lang="scss">
</style>
